import type { InspectionSchedule, InspectionScheduleBase } from "../../types";
import { createBaseService } from "./baseService";

const base = createBaseService<InspectionSchedule, InspectionScheduleBase>({
  tableName: "inspection_schedules",
  viewName: "inspection_schedules_enriched",
  searchColumns: ["title"],
  computedColumns: ["templateName", "locationName", "assetName", "assigneeName"],
});

export class InspectionScheduleService {
  static getAll = base.getAll;
  static get = base.get;
  static create = base.create;
  static update = base.update;
  static delete = base.delete;
}
